import { FormInput } from "@/components/forms/FormInput";
import { FormSubmitButton } from "@/components/forms/FormSubmitButton";
import { FormWrapper } from "@/components/forms/FormWrapper";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Routes } from "@/config/routes";
import { userGroups } from "@/endpoints/dryp/userGroups";
import { useAsyncStateStore } from "@/hooks/useAsyncStateStore";
import { useFormHandler } from "@/hooks/useFormHandler";
import { observer } from "mobx-react-lite";
import { useNavigate } from "react-router";
import { z } from "zod";

const validationFormSchema = z.object({
	name: z.string(),
	description: z.string(),
});
type AddUserGroupFormValues = z.infer<typeof validationFormSchema>;

export const AddUserGroup = observer(() => {
	const addUserGroupApi = useAsyncStateStore(userGroups.addUserGroup);
	const { form, handleFormErrors } = useFormHandler(validationFormSchema);
	const navigate = useNavigate();

	const onSubmit = async (fomrData: AddUserGroupFormValues) => {
		try {
			await addUserGroupApi.fetch(fomrData);
			navigate(Routes.Dashboard.Admin.UserGroups.path);
		} catch (error) {
			handleFormErrors(error);
		}
	};

	return (
		<Card className="m-4 w-1/3">
			<CardHeader>
				<CardTitle>Create new user group</CardTitle>
			</CardHeader>
			<CardContent>
				<FormWrapper form={form} onSubmit={onSubmit}>
					<FormInput name="name" type="text" label="Name" placeholder="Type user group name" required />
					<FormInput
						name="description"
						type="text"
						label="Description"
						placeholder="Type user group description"
						required
					/>

					<FormSubmitButton
						isLoading={addUserGroupApi.loading}
						buttonText="Add user group"
						buttonLoadingText="Adding new user group ..."
					/>
				</FormWrapper>
			</CardContent>
		</Card>
	);
});
